module.exports = __webpack_public_path__ + "img/comment-dots.d00076e3.svg";